import { Link } from "@quintype/components";
import { TitleCardSkeleton } from "../skeleton/DesktopSkelton";
import React from "react";
import { timeAgo } from "../../utils/published-date";

export default function TitleAuthorCard({ story }) {
  if (!story) {
    return (
      <div className="mb-5">
        <TitleCardSkeleton />
      </div>
    );
  }
  return (
    <Link href={`/${story.story.slug}`}>
      <div className="mb-5 cursor-pointer">
        <div className="">
          <div>
            <h4 className="mb-2 pt-0 text-base font-[470] hover:text-[#737275]">{story.story.headline}</h4>
            <div className="flex flex-row items-center justify-start gap-3 text-xs">
              <div className="relative leading-[18px] text-[#ca4242]">
                <span> {story.story.authors[0].name}</span>
              </div>
              <div className="relative leading-[18px] text-[#737275]">
                <span>{timeAgo(story.story["content-updated-at"])}</span>

                {/* <span className="mx-1 text-primary">|</span> */}
                {/* <span>
                    {story.sections[0]["name"] ||
                      story.sections[0]["display_name"]}
                  </span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
